module.exports = __webpack_public_path__ + "static/media/zagreb_logo.4d021080.png";